module.exports = __webpack_public_path__ + "media/bootstrap-icons/volume-down-7fac32ad.svg";